"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckOnSVG = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const CheckOnSVG = exports.CheckOnSVG = /*#__PURE__*/_react.default.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("rect", {
  width: "24",
  height: "24",
  rx: "4",
  fill: "#0000FF"
}), /*#__PURE__*/_react.default.createElement("path", {
  d: "M16.2924 7.56104C16.3705 7.48042 16.4996 7.47987 16.5784 7.55983L17.8626 8.86284C17.9389 8.94034 17.9393 9.06466 17.8635 9.14266L10.8484 16.356C10.7703 16.4363 10.6414 16.4368 10.5627 16.3571L6.13866 11.878C6.06178 11.8001 6.06171 11.675 6.1385 11.5971L7.423 10.2937C7.50125 10.2143 7.6293 10.2142 7.70767 10.2934L10.7061 13.3258L16.2924 7.56104Z",
  fill: "#F6F6F9"
}));